<template>
  <div class="animated fadeIn calendar-manager">
    <div class="row">
      <div class="col-md-12">
        <div class="date-selected">
          <div class="text">Date selected</div>
          <div class="month-day">{{today.format('MMMM')}} {{today.date()}} <span class="year">{{today.year()}}</span>
          </div>
          <div class="date-status open" v-if="lockedDates.indexOf(today.format('MM/DD/YYYY')) < 0">open</div>
          <div class="date-status blocked" v-if="lockedDates.indexOf(today.format('MM/DD/YYYY')) >= 0">blocked</div>
          <button class="btn-packing-slip-wrapper ap-btn primary" @click="downloadPackingSlip()">
            Create Packing Slip
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">

      </div>
    </div>
    <div class="calendar-and-event-container">
      <div class="left-side">
          <div>
            <div class="text-header">
              Calendar
              <button class="today-btn ap-btn secondary" @click="setToday()">today</button>
            </div>
            <CalendarDatePicker :showLeft="true" v-on:input="selectDate" v-on:selectDate="setSelected"
                                :datesHasData="datesHasData"
                                :lockedDates="lockedDates" :selectedDate="selectedDate"
                                :dateRangeHasData="dateRangeHasData"
                                v-on:getDateRangeHasData="getDateRangeHasData"></CalendarDatePicker>
            <div class="action-btn-panel">
              <button class="action-btn open ap-btn primary" @click="openSelectedDate()"
                   v-if="lockedDates.indexOf(today.format('MM/DD/YYYY')) >= 0">open date
              </button>
              <button class="action-btn block ap-btn destructive" @click="blockSelectedDate()"
                   v-if="lockedDates.indexOf(today.format('MM/DD/YYYY')) < 0">block date
              </button>
            </div>
          </div>
      </div>
      <div class="right-side">
        <div>
          <div :class="{'isLoading': getLoading, 'noDisplay': !getLoading}" class="overlay">
            <div class="spinner-align">
              <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
            </div>
          </div>
          <div class="text-header">Events</div>
          <div class="text-content" v-if="getTotalApprovedEvents == 0">
            No events found for the date selected
          </div>
          <template v-for="(item, index) in getEvents">
            <div class="cheetah-digital"><span>{{ item.clientName }}</span></div>
            <div class="event-cards-wrapper">
              <EventCard :key="index" :event="event" v-for="(event, index) in item.events"
                         :isNoTrans="index % 3 == 2"></EventCard>
            </div>
            <div class="clear-both"></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CalendarDatePicker from '../../components/commons/CalendarDatePicker.vue';
  import {mapActions, mapGetters} from 'vuex';
  import EventCard from '../../components/eventManagement/manage/EventCard';
  import moment from 'moment';
  import 'vue-awesome/icons/spinner';
  import Icon from 'vue-awesome/components/Icon';
  import constants from '../../_consts';

  export default {
    name: 'calendar-manager',
    components: {
      CalendarDatePicker,
      EventCard,
      Icon
    },
    data () {
      return {
        today: moment(),
        selectedDate: moment()
      }
    },
    methods: {
      selectDate (selectedDate) {
        this.getDateHasData(selectedDate);
        this.today = moment(selectedDate, 'MM/DD/YYYY');
      },
      setToday () {
        this.today = moment();
        this.selectedDate = moment();
        this.setSelected(this.selectedDate.format('MM/DD/YYYY'));
        this.$bus.$emit('set-today');
      },
      setSelected (dateStr) {
        this.selectedDate = moment(dateStr, 'MM/DD/YYYY');
        let body = {
          noOfDates: null, // 100 is represent for 60+, can be any number which is bigger than 60
          selectedDate: dateStr,
          changeFilter: true
        };
        this.getEventByDate(body).then(response => {
          if (response.message !== null || response.message !== '') {
            console.log('Events by selected date: ', response.approvedEvents);
            console.log('Total Event found: ', response.totalEvents);
          } else {
            console.log(response.message);
          }
        });
      },
      openSelectedDate () {
        this.$swal({
          title: "<div class='ems_alert_title'>open date</div>",
          html: "<div class='ems_alert_des'>Opening this date will allow clients to sign up for biometric events on this day.</div>",
          confirmButtonColor: '#0080A5',
          confirmButtonText: 'OPEN DATE',
          showCancelButton: true,
          cancelButtonColor: '#fff',
          cancelButtonText: 'CANCEL',
          buttonsStyling: true,
          reverseButtons: true,
          confirmButtonClass: 'ems_alert_confirm open',
          cancelButtonClass: 'ems_alert_cancel',
          customClass: 'ems_confirm',
          allowOutsideClick: false,
          allowEscapeKey: false,
          width: 605
        }).then((result) => {
          if (result.value) {
            this.openDate(this.selectedDate.format('MM/DD/YYYY')).then((res) => {
              console.log('open date res:', res);
            });
          }
        });
      },
      blockSelectedDate () {
        this.$swal({
          title: "<div class='ems_alert_title'>block date</div>",
          html: "<div class='ems_alert_des'>Blocking this date will not allow any further clients to sign up for biometric events on this day.<br /><br />Clients that have already signed up will not be affected.<br /><br />You can undo this at any time.</div>",
          confirmButtonColor: '#FF3400',
          confirmButtonText: 'BLOCK DATE',
          showCancelButton: true,
          cancelButtonColor: '#fff',
          cancelButtonText: 'CANCEL',
          buttonsStyling: true,
          reverseButtons: true,
          confirmButtonClass: 'ems_alert_confirm block',
          cancelButtonClass: 'ems_alert_cancel',
          customClass: 'ems_confirm',
          allowOutsideClick: false,
          allowEscapeKey: false,
          width: 605
        }).then((result) => {
          if (result.value) {
            this.blockDate(this.selectedDate.format('MM/DD/YYYY')).then((res) => {
              console.log('block date res:', res);
            });
          }
        });
      },
      downloadPackingSlip () {
        this.getURLForPackingSlip().then(response => {
          if (response.message === null) {
            this.downloadPackingSlipExcel(response.data).then(response => {
              // console.log(response);
            });
          } else {
            this.$toast.error(response.message, '', {
              ...this.$toastOpt.optError
            });
          }
        })
      },
      ...mapActions({
        getDateHasData: 'ACTION_GET_DATE_HAS_DATA',
        getDateRangeHasData: 'ACTION_GET_DATE_RANGE_HAS_DATA',
        getLockedDate: 'ACTION_LOCKED_DATE',
        blockDate: 'ACTION_BLOCK_DATE',
        openDate: 'ACTION_OPEN_DATE',
        getEventByDate: 'ACTION_GET_EVENTS_BY_DATES',
        getURLForPackingSlip: 'ACTION_GET_URL_FOR_PACKING_SLIP',
        downloadPackingSlipExcel: 'ACTION_DOWNLOAD_PACKING_SLIP'
      })
    },
    computed: {
      ...mapGetters({
        getLoading: 'GETTERS_IS_LOADING',
        getEvents: 'GETTERS_EVENTS_BY_DATES',
        getTotalApprovedEvents: 'GETTERS_TOTAL_EVENTS',
        datesHasData: 'GETTERS_DATES_HAS_DATA',
        lockedDates: 'GETTERS_LOCKED_DATES',
        dateRangeHasData: 'GETTERS_DATE_RANGE_HAS_DATA'
      })
    },
    mounted () {
      this.getDateHasData(moment().format('MM/DD/YYYY'));
      this.getLockedDate();
      this.$store.commit('MUTATION_SET_MANAGER_VIEW', constants.viewNames.staffing);
    }
  };
</script>

<style lang="less">
  .calendar-manager {
    .date-selected {
      height: 96px;
      border-radius: 3px;
      background-color: #FFFFFF;
      padding: 15px 24px;
      .text {
        height: 16px;
        color: #444444;
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        letter-spacing: 0.1px;
        line-height: 16px;
        text-transform: uppercase;
      }
      .month-day {
        height: 32px;
        color: #1D1D1D;
        font-family: "Open Sans", sans-serif;
        font-size: 24px;
        font-weight: 600;
        letter-spacing: 0.2px;
        line-height: 32px;
        text-transform: capitalize;
        float: left;
        .year {
          height: 32px;
          color: #8E8E8E;
          font-family: "Open Sans", sans-serif;
          font-size: 24px;
          font-weight: 600;
          letter-spacing: 0.2px;
          line-height: 32px;
        }
      }
      .date-status {
        height: 22px;
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        letter-spacing: 0.1px;
        line-height: 22px;
        float: left;
        margin-top: 5px;
        padding: 1px 10px;
        text-transform: uppercase;
        color: #FFF;
        border-radius: 10px;
        margin-left: 8px;
        &.open {
          background-color: #68B814;
        }
        &.blocked {
          background-color: #FF3400;
        }
      }
      .btn-packing-slip-wrapper {
        border-radius: 4px;
        display: inline-block;
        margin-left: 20px;
        padding: 6px 24px;

        .label {
          color: #FFF;
          font-family: "Open Sans", sans-serif;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0.1px;
          line-height: 20px;
          cursor: pointer;
          position: relative;
          top: 50%;
          left: 50%;
          float: left;
          transform: translate(-50%, -50%);
        }
      }
    }
    .text-header {
      color: #444444;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      font-weight: bold;
      line-height: 70px;
      height: 60px;
      .today-btn {
        border-radius: 4px;
        position: absolute;
        top: 20px;
        right: 0;
        text-transform: uppercase;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.1px;
        padding: 6px 24px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .text-content {
      height: 16px;
      color: #626262;
      font-family: "Open Sans", sans-serif;
      font-size: 12px;
      line-height: 16px;
    }

    .calendar-and-event-container{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 12px 24px;

      .left-side {
        width: 320px;

        .date-picker{
          .date-panel{
            position: relative;
          }
        }

        .action-btn-panel {
          padding: 8px 0;

          .action-btn {
            border-radius: 4px;
            float: right;
            color: #FFFFFF;
            font-family: "Open Sans", sans-serif;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0.1px;
            text-align: center;
            text-transform: uppercase;
            padding: 6px 24px;
          }
        }
      }
      .right-side {
        padding-left: 24px;
        .cheetah-digital {
          height: 16px;
          width: 110px;
          color: #626262;
          font-family: "Open Sans", serif;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 11px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .event-cards-wrapper {
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;
          margin: 0 -12px;

          .event-card-container{
            margin: 12px;
          }
        }
      }
    }
  }

  .overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 167px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    cursor: pointer;
  }

  .isLoading {
    display: block;
    text-align: center;
    color: #606060;
  }

  .noDisplay {
    display: none;
  }

  .spinner-align {
    position: absolute;
    top: 33%;
    left: 50%;
    font-size: 50px;
    color: white;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// Calendar.vue?57a5f75e